import { ModelBase } from "../shared/model.base";

export class Country extends ModelBase {
    id: number;
    name: "";
    area_code: number;
    active: boolean;
    display_area_code: string;
    isocode: string;

    constructor() {
        super();
    }
}
